<template>
  <div style="text-align: right; padding-top: 20px">
    <el-pagination ref="pg" v-bind="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="data.current" :total="total" />
  </div>
</template>

<script>
  export default {
    name: 'vPagination',
    props: {
      value: {
        default: () => ({ no: 1, size: 10 }),
        type: Object
      },
      sizes: {
        default: ()=>[10, 20, 50, 100,500],
        type: Array
      },
      size: {
        default: 100,
        type: Number
      },
      total: {
        default: 1,
        type: Number
      }
    },
    data() {
      return {
        data: {}
      };
    },
    watch: {
      total(n) {
        this.$refs.pg.$forceUpdate()
      }
    },
    created() {
      this.data = {
        ...this.value
      };
      this.pagination = {
        'pager-count': 5,
        background: true,
        'page-size': this.size,
        'page-sizes': this.sizes,
        layout: 'total, sizes, prev, pager, next, jumper'
      };
    },
    methods: {
      handleSizeChange(value) {
        this.data.size = value;
        this.$emit('input', this.data);
        this.$emit('update');
      },
      handleCurrentChange(value) {
        this.data.current = value;
        this.data.no = value;
        this.$emit('input', this.data);
        this.$emit('update');
      }
    }
  };
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/cuscom/paging.vue